import { makeStyles } from "@material-ui/core/styles";
import "../../../css/Terms.css";
import { AuthorName } from "../../shared/Author/Author";
import Helmet from "../../shared/Helmet";

export default function Terms() {
    const c = useStyles();

    return (
        <div className="terms">
            <Helmet
                title="Terms of Use"
                desc="Website Terms of Use - Lingual Ninja"
            />
            <div className="center">
                <h1>
                    <span className={c.titleLine}>Lingual Ninja</span>{" "}
                    <span className={c.titleLine}>Terms of Use</span>
                </h1>
                <div className="contents">
                    <hr />
                    <h2>The Ownership of Website</h2>
                    <p>
                        This website is developed and owned by{" "}
                        <AuthorName title="Developer" />. When you want to use
                        any quotes, images, or programs, you must get approval
                        from the owner.
                    </p>
                    <hr />
                    <h2>Responsibility</h2>
                    <p>
                        If user experiences trouble including defects or bugs,
                        the owner of this website can't be held liable. It will
                        be user's responsibility.
                    </p>
                    <hr />
                    <h2>Account Usage Restrictions</h2>
                    <p>
                        In order to make Lingual Ninja an enjoyable experience
                        for all users, functionality may be restricted for users
                        who engage in the following actions:
                        <ul className={c.ul}>
                            <li className={c.li}>
                                If there is an act of causing trouble to other
                                users or posting abusive language, that user's
                                functions may be restricted.
                            </li>
                            <li>
                                If the above actions or automated operations by
                                programs or AI are detected, the account itself
                                may be frozen.
                            </li>
                            <li>
                                Any other acts of cheating or nuisance will be
                                subject to the same penalties as above.
                            </li>
                        </ul>
                        Only users who agree with the above should create an
                        account on this website.
                    </p>
                </div>
            </div>
        </div>
    );
}
const useStyles = makeStyles({
    titleLine: { whiteSpace: "nowrap" },
    ul: { marginTop: 10 },
    li: { marginBottom: 5 },
});
